<div id="report-view" class="report-view">
    <header class="report-actions" data-html2canvas-ignore>
        <app-monitoring-filters
            [isLoading]="isProcessing"
            [filters]="filters" (selectionChange)="onSelectionChange($event)"
        ></app-monitoring-filters>
    </header>
    <app-monitoring-results [filters]="filters" [results]="results"></app-monitoring-results>
</div>
